import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  Typography,
  Button,
  Divider,
  LinearProgress,
  Stack,
  Alert,
  AlertTitle,
  Box,
  Modal as MuiModal,
  CardContent,
  CardHeader,
  IconButton,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";

import BusinessIcon from "@mui/icons-material/Business";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PermContactCalendarIcon from "@mui/icons-material/PermContactCalendar";
import SupportIcon from "@mui/icons-material/Support";
import CloseIcon from "@mui/icons-material/Close";

import SwitchOrganization from "./drawers/switchOrganization";
import Ticket from "../Ticket";

import useAuthStore from "../../../stores/auth";
import useNavStore from "../../../stores/nav";
import { fetchData } from "../../../fetchData";

import DashboardRRTasks from "./rrTasks";
// FeatureFeedback é usado em outros fluxos de CES

function Dashboard() {
  const navigate = useNavigate();
  const user: any = useAuthStore((state) => state.user);
  const company = useAuthStore((state) => state.company);
  const setHeaderTitle = useNavStore((state) => state.setHeader);
  const [showGratificacaoModal, setShowGratificacaoModal] = useState(false);
  const [latestVideoId, setLatestVideoId] = useState<string | null>(null);
  const [showAfastamentosModal, setShowAfastamentosModal] = useState(false);
  const [latestAfastamentosVideoId, setLatestAfastamentosVideoId] = useState<
    string | null
  >(null);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [productAnswer, setProductAnswer] = useState<string | null>(null);
  const [productComment, setProductComment] = useState("");
  const [productTouched, setProductTouched] = useState(false);
  const [productSubmitting, setProductSubmitting] = useState(false);
  const [productSent, setProductSent] = useState(false);
  const [shouldAskProductFeedback, setShouldAskProductFeedback] =
    useState(false);
  const productFeedbackRequestedRef = useRef(false);
  const showAfastamentosModalRef = useRef(showAfastamentosModal);
  // const [showNpsModal, setShowNpsModal] = useState(false);
  // const [latestNpsId, setLatestNpsId] = useState<string | null>(null);
  // const [shouldCheckNps, setShouldCheckNps] = useState(false);
  // const [latestNpsData, setLatestNpsData] = useState<any>(null);
  // const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  // const hasUserAnsweredSurvey = (
  //   userScores: any[],
  //   surveyId: string,
  // ): boolean => {
  //   return userScores?.some(
  //     (score: any) =>
  //       score.survey === surveyId ||
  //       score.survey?._id === surveyId ||
  //       String(score.survey) === String(surveyId),
  //   );
  // };

  // const createNullNpsScore = async () => {
  //   if (!latestNpsId || !user?._id || !latestNpsData?.questions) {
  //     return;
  //   }
  //
  //   const questions = latestNpsData.questions.map((question: string) => ({
  //     question,
  //     value: null,
  //     comment: null,
  //   }));
  //
  //   const data = {
  //     survey: latestNpsId,
  //     answers: questions,
  //   };
  //
  //   await fetchData(`/surveys/nps/score?userid=${user._id}`, {
  //     method: "POST",
  //     body: JSON.stringify(data),
  //   });
  // };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "95%", sm: "90%", md: 750 },
    maxWidth: 750,
    maxHeight: { xs: "90vh", md: "85vh" },
    p: 0,
    zIndex: 1301,
    overflow: "auto",
  };

  useEffect(() => {
    setHeaderTitle(`Olá, ${user?.nickname}.`);
  }, [setHeaderTitle, user?.nickname]);

  useEffect(() => {
    const checkClientProfile = async () => {
      if (!company || company.state || !company.reference) return;

      const currentMonth = new Date().getMonth() + 1;
      if (currentMonth !== 11 && currentMonth !== 12) return;

      try {
        const clientData = await fetchData(
          `/organizations/${company.reference}/ref`,
          {
            method: "GET",
          },
        );

        if (clientData?.profile === "Igrejas") {
          setLatestVideoId("0vuBYCNskPg");
          setShowGratificacaoModal(true);
        }
      } catch (error) {
        console.log(error);
      }
    };

    checkClientProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company]);

  useEffect(() => {
    if (!company || company.state) return;

    setLatestAfastamentosVideoId("kq1NXxQbDN8");
    setShowAfastamentosModal(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company]);

  useEffect(() => {
    if (!company || company.state) return;
    if (productFeedbackRequestedRef.current) return;

    const checkProductFeedback = async () => {
      try {
        const feedbackState = await fetchData("/feedback/track", {
          method: "POST",
          body: JSON.stringify({ context: "csat_web" }),
        });

        if (feedbackState?.shouldAsk) {
          setShouldAskProductFeedback(true);
        }
      } catch (error) {
        console.log(error);
      } finally {
        productFeedbackRequestedRef.current = true;
      }
    };

    checkProductFeedback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company]);

  useEffect(() => {
    showAfastamentosModalRef.current = showAfastamentosModal;
  }, [showAfastamentosModal]);

  useEffect(() => {
    if (!shouldAskProductFeedback) return;

    let timeoutId: number | undefined;

    if (!showAfastamentosModal) {
      timeoutId = window.setTimeout(() => {
        if (!showAfastamentosModalRef.current) {
          setShowFeedbackModal(true);
        }
      }, 1000);
    }

    return () => {
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    };
  }, [shouldAskProductFeedback, showAfastamentosModal]);

  // useEffect(() => {
  //   const checkNpsSurvey = async () => {
  //     if (!user?._id || showGratificacaoModal) return;
  //
  //     try {
  //       const npsList = await fetchData(`/surveys/nps?limit=1&order=desc`, {
  //         method: "GET",
  //       });
  //
  //       if (!npsList?.rows || npsList.rows.length === 0) return;
  //
  //       const latestNps = npsList.rows[0];
  //       setLatestNpsId(latestNps._id);
  //       setLatestNpsData(latestNps);
  //
  //       try {
  //         const userScores = await fetchData(
  //           `/users/${user._id}/surveys/nps/scores`,
  //           {
  //             method: "GET",
  //           },
  //         );
  //
  //         if (!hasUserAnsweredSurvey(userScores, latestNps._id)) {
  //           setShowNpsModal(true);
  //         }
  //       } catch (error) {
  //         console.log(error);
  //       }
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   };
  //
  //   checkNpsSurvey();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [user]);
  //
  // useEffect(() => {
  //   if (shouldCheckNps && !showGratificacaoModal && latestNpsId && user?._id) {
  //     const checkNpsAfterGratificacao = async () => {
  //       try {
  //         const userScores = await fetchData(
  //           `/users/${user._id}/surveys/nps/scores`,
  //           {
  //             method: "GET",
  //           },
  //         );
  //
  //         if (!hasUserAnsweredSurvey(userScores, latestNpsId)) {
  //           setShowNpsModal(true);
  //         }
  //         setShouldCheckNps(false);
  //       } catch (error) {
  //         console.log(error);
  //         setShouldCheckNps(false);
  //       }
  //     };
  //
  //     checkNpsAfterGratificacao();
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [shouldCheckNps, showGratificacaoModal]);

  return (
    <>
      <Grid container spacing={3}>
        <Grid xs={12} md={4}>
          <Card>
            {company.state && <LinearProgress />}
            {!company.state && (
              <>
                <Typography variant="h3" fontWeight={700}>
                  {company?.reference}
                </Typography>
                <Typography variant="body2" color="text.disabled">
                  {company?.name}
                </Typography>
                <Stack
                  spacing={2}
                  direction={{ xs: "column", xl: "row" }}
                  sx={{ mt: 2 }}
                >
                  {user?.client.length > 1 && <SwitchOrganization />}
                  <Button
                    sx={{ flex: 1 }}
                    variant="outlined"
                    size="medium"
                    startIcon={<BusinessIcon />}
                    onClick={() => navigate("/mycompany")}
                  >
                    Minha PJ
                  </Button>
                </Stack>
              </>
            )}
          </Card>
          <Card sx={{ mt: 3 }}>
            <Typography variant="h5">Acesso Rápido</Typography>
            <Divider sx={{ my: 3 }} />
            <Button
              fullWidth
              variant="contained"
              size="medium"
              color="success"
              startIcon={<WhatsAppIcon />}
              sx={{ mb: 2 }}
              onClick={() => window.open("https://wa.me/551130030506")}
            >
              WhatsApp
            </Button>
            <Ticket />
            {user?.profile?.includes("ADMIN") && (
              <Button
                fullWidth
                variant="contained"
                size="medium"
                color="secondary"
                startIcon={<PermContactCalendarIcon />}
                sx={{ mt: 2 }}
                onClick={() => navigate("/contacts")}
              >
                Contatos de Relacionamento
              </Button>
            )}
            <Button
              fullWidth
              variant="contained"
              size="medium"
              color="error"
              startIcon={<SupportIcon />}
              sx={{ mt: 2 }}
              onClick={() => navigate("/help")}
            >
              Central de Ajuda
            </Button>
          </Card>
        </Grid>
        <Grid xs={12} md={8}>
          <Card>
            <Typography variant="h5">Últimas atividades</Typography>
            <Divider sx={{ my: 3 }} />
            <DashboardRRTasks />
          </Card>
        </Grid>
      </Grid>
      <MuiModal
        open={showFeedbackModal}
        onClose={() => {
          if (productSubmitting) return;
          setShowFeedbackModal(false);
        }}
        BackdropComponent={Backdrop}
        BackdropProps={{
          sx: {
            backgroundColor: "rgba(0, 0, 0, 0.7)",
          },
        }}
      >
        <Card sx={modalStyle}>
          <CardContent sx={{ p: 3 }}>
            <Stack spacing={3} alignItems="center">
              {!productSent && (
                <>
                  <Typography variant="h6" textAlign="center">
                    Como você avalia sua experiência geral com a plataforma
                    hoje?
                  </Typography>

                  <Stack spacing={2.5} alignItems="center">
                    <Typography variant="body2">
                      Selecione uma opção de 1 a 5:
                    </Typography>
                    <Stack
                      direction="row"
                      justifyContent="center"
                      alignItems="flex-start"
                      sx={{ width: "100%" }}
                    >
                      {[
                        {
                          score: 1,
                          answer: "very_dissatisfied",
                          label: "Muito insatisfeito",
                        },
                        {
                          score: 2,
                          answer: "dissatisfied",
                          label: "Insatisfeito",
                        },
                        {
                          score: 3,
                          answer: "neutral",
                          label: "Neutro",
                        },
                        {
                          score: 4,
                          answer: "satisfied",
                          label: "Satisfeito",
                        },
                        {
                          score: 5,
                          answer: "very_satisfied",
                          label: "Muito satisfeito",
                        },
                      ].map((item) => (
                        <Stack
                          key={item.score}
                          direction="column"
                          spacing={0.5}
                          alignItems="center"
                        >
                          <Button
                            variant={
                              productAnswer === item.answer
                                ? "contained"
                                : "outlined"
                            }
                            onClick={() => {
                              setProductAnswer(item.answer);
                              if (!productTouched) setProductTouched(true);
                            }}
                            sx={{
                              borderRadius: "50%",
                              minWidth: 40,
                              width: 40,
                              height: 40,
                              p: 0,
                            }}
                            type="button"
                          >
                            {item.score}
                          </Button>
                          <Typography
                            variant="caption"
                            textAlign="center"
                            sx={{ width: 140 }}
                          >
                            {item.score}. {item.label}
                          </Typography>
                        </Stack>
                      ))}
                    </Stack>
                    {productTouched &&
                      (!productAnswer || productAnswer.length === 0) && (
                        <Typography
                          variant="caption"
                          color="error"
                          sx={{ mt: 1 }}
                        >
                          Por favor, selecione uma opção de 1 a 5.
                        </Typography>
                      )}
                  </Stack>

                  <Box sx={{ width: "100%" }}>
                    <Stack spacing={2}>
                      <Box
                        component="textarea"
                        value={productComment}
                        onChange={(e: any) =>
                          setProductComment(e.target.value || "")
                        }
                        style={{
                          width: "100%",
                          minHeight: 80,
                          resize: "vertical",
                          padding: 8,
                          borderRadius: 4,
                          border: "1px solid #ccc",
                          fontFamily: "inherit",
                          fontSize: "0.875rem",
                        }}
                        placeholder="Teve algum problema ou tem alguma sugestão? Conta pra gente!"
                      />
                      <Stack
                        direction={{ xs: "column", sm: "row" }}
                        spacing={1}
                        sx={{ width: "100%", justifyContent: "space-between" }}
                      >
                        <Button
                          size="small"
                          onClick={async () => {
                            if (productSubmitting) return;
                            setProductSubmitting(true);
                            try {
                              await fetchData("/feedback/skip", {
                                method: "POST",
                                body: JSON.stringify({
                                  context: "csat_web",
                                }),
                              });
                            } catch (e) {
                              console.log(e);
                            }
                            setProductSubmitting(false);
                            setShowFeedbackModal(false);
                          }}
                          type="button"
                          disabled={productSubmitting}
                          sx={{
                            width: { xs: "100%", sm: "auto" },
                            flex: { xs: 1, sm: "0 1 auto" },
                          }}
                        >
                          Pular
                        </Button>
                        <Button
                          size="small"
                          variant="contained"
                          onClick={async () => {
                            setProductTouched(true);
                            if (!productAnswer || productAnswer.length === 0)
                              return;
                            if (productSubmitting) return;
                            setProductSubmitting(true);
                            try {
                              await fetchData("/surveys/csat", {
                                method: "POST",
                                body: JSON.stringify({
                                  type: "web",
                                  answer: productAnswer,
                                  comments: productComment || null,
                                }),
                              });
                              setProductSent(true);
                            } catch (e) {
                              console.log(e);
                            }
                            setProductSubmitting(false);
                          }}
                          type="button"
                          disabled={productSubmitting}
                          sx={{
                            width: { xs: "100%", sm: "auto" },
                            flex: { xs: 1, sm: "0 1 auto" },
                          }}
                        >
                          {productSubmitting ? (
                            <CircularProgress size={18} color="inherit" />
                          ) : (
                            "Enviar Avaliação"
                          )}
                        </Button>
                      </Stack>
                    </Stack>
                  </Box>
                </>
              )}

              {productSent && (
                <Stack spacing={2} alignItems="center">
                  <Typography variant="h6" textAlign="center">
                    Obrigado!
                  </Typography>
                  <Typography variant="body2" textAlign="center">
                    Sua avaliação foi enviada com sucesso.
                  </Typography>
                  <Button
                    size="small"
                    variant="contained"
                    onClick={() => setShowFeedbackModal(false)}
                  >
                    Fechar
                  </Button>
                </Stack>
              )}
            </Stack>
          </CardContent>
        </Card>
      </MuiModal>
      <MuiModal
        open={showGratificacaoModal}
        onClose={() => {
          setShowGratificacaoModal(false);
          // if (latestNpsId) {
          //   setShouldCheckNps(true);
          // }
        }}
        BackdropComponent={Backdrop}
        BackdropProps={{
          sx: {
            backgroundColor: "rgba(0, 0, 0, 0.7)",
          },
        }}
      >
        <Card sx={modalStyle}>
          <CardHeader
            sx={{ borderBottom: "1px solid #CCCC" }}
            title={
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
              >
                <Typography variant="h6" component="span" fontWeight={600}>
                  Gratificação Natalina
                </Typography>
                <IconButton
                  aria-label="fechar"
                  size="small"
                  onClick={() => setShowGratificacaoModal(false)}
                  edge="end"
                >
                  <CloseIcon />
                </IconButton>
              </Stack>
            }
          />
          <CardContent sx={{ p: 2 }}>
            <Stack spacing={2}>
              <Typography variant="body2">
                Neste vídeo, apresentamos o passo a passo para inserir a
                gratificação natalina na plataforma.
              </Typography>
              <Typography variant="body2">
                Acompanhe as orientações e aprenda como realizar o procedimento
                de forma correta e segura, garantindo o correto lançamento dos
                valores aos colaboradores.
              </Typography>
              {latestVideoId && (
                <Box
                  sx={{
                    position: "relative",
                    width: "100%",
                    paddingBottom: "56.25%",
                    borderRadius: 1,
                    overflow: "hidden",
                  }}
                >
                  <Box
                    component="iframe"
                    src={`https://www.youtube.com/embed/${latestVideoId}`}
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      border: 0,
                    }}
                    allowFullScreen
                  />
                </Box>
              )}
            </Stack>
          </CardContent>
        </Card>
      </MuiModal>
      <MuiModal
        open={showAfastamentosModal}
        onClose={() => {
          setShowAfastamentosModal(false);
        }}
        BackdropComponent={Backdrop}
        BackdropProps={{
          sx: {
            backgroundColor: "rgba(0, 0, 0, 0.7)",
          },
        }}
      >
        <Card sx={modalStyle}>
          <CardHeader
            sx={{ borderBottom: "1px solid #CCCC" }}
            title={
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
              >
                <Typography variant="h6" component="span" fontWeight={600}>
                  Novo módulo contábil
                </Typography>
                <IconButton
                  aria-label="fechar"
                  size="small"
                  onClick={() => setShowAfastamentosModal(false)}
                  edge="end"
                >
                  <CloseIcon />
                </IconButton>
              </Stack>
            }
          />
          <CardContent sx={{ p: 2 }}>
            <Stack spacing={2}>
              <Typography variant="body2">
                Neste webinar, feito ao vivo, apresentamos o mais novo módulo
                contábil! Assista ao vídeo atentamente para entender como
                funciona este novo módulo, qualquer dúvida estamos à disposição
                em nossos canais de atendimento. Obrigado!
              </Typography>
              <Alert severity="info" sx={{ mb: 1 }}>
                <AlertTitle>Importante</AlertTitle>
                Devido à implementação deste novo módulo, a partir de 01/03/2026
                a guia de arquivos não permitirá mais a inserção de novos
                arquivos, sendo possível apenas consultar os arquivos já
                existentes.
              </Alert>
              {latestAfastamentosVideoId && (
                <Box
                  sx={{
                    position: "relative",
                    width: "100%",
                    paddingBottom: "56.25%",
                    borderRadius: 1,
                    overflow: "hidden",
                  }}
                >
                  <Box
                    component="iframe"
                    src={`https://www.youtube.com/embed/${latestAfastamentosVideoId}`}
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      border: 0,
                    }}
                    allowFullScreen
                  />
                </Box>
              )}
            </Stack>
          </CardContent>
        </Card>
      </MuiModal>
      {/* <MuiModal
        open={showNpsModal}
        onClose={() => setShowNpsModal(false)}
        BackdropComponent={Backdrop}
        BackdropProps={{
          sx: {
            backgroundColor: "rgba(0, 0, 0, 0.7)",
          },
        }}
      >
        <Card sx={modalStyle}>
          <CardHeader
            sx={{ borderBottom: "1px solid #CCCC" }}
            title={
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
              >
                <Typography variant="h6" component="span" fontWeight={600}>
                  Avaliação NPS
                </Typography>
                <IconButton
                  aria-label="fechar"
                  size="small"
                  onClick={() => setShowNpsModal(false)}
                  edge="end"
                >
                  <CloseIcon />
                </IconButton>
              </Stack>
            }
          />
          <CardContent sx={{ p: 2 }}>
            <Stack spacing={2}>
              <Typography variant="body2">
                Notamos que você ainda não respondeu nossa pesquisa NPS
              </Typography>
              <Typography variant="body2">
                Sua opinião é muito importante para nós! Clique no link abaixo
                para acessar a pesquisa e compartilhar sua experiência.
              </Typography>
              {latestNpsId && (
                <Box>
                  <Link
                    href={`https://surveys.atlantico.digital/nps/${latestNpsId}?userid=${user?._id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      fontSize: "1rem",
                      fontWeight: 500,
                      wordBreak: "break-word",
                    }}
                  >
                    Acessar pesquisa NPS
                  </Link>
                </Box>
              )}
              <Alert severity="warning" sx={{ mt: 2 }}>
                <AlertTitle>Aviso Importante</AlertTitle>
                Após clicar no link da pesquisa, não feche ou atualize a tela
                até concluir a avaliação.
              </Alert>
              <Divider />
              <Stack direction="row" spacing={2}>
                <Button
                  variant="contained"
                  color="error"
                  fullWidth
                  onClick={() => setShowConfirmDialog(true)}
                  sx={{ textTransform: "none" }}
                >
                  Não quero receber mais este aviso
                </Button>
                <Button
                  variant="outlined"
                  fullWidth
                  onClick={() => setShowNpsModal(false)}
                  sx={{ textTransform: "none" }}
                >
                  Fechar
                </Button>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      </MuiModal>
      <Dialog
        open={showConfirmDialog}
        onClose={() => setShowConfirmDialog(false)}
      >
        <DialogTitle>Confirmar ação</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Tem certeza que não deseja receber mais avisos sobre esta pesquisa
            NPS? Você não receberá mais notificações sobre esta avaliação.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowConfirmDialog(false)}>Cancelar</Button>
          <Button
            color="error"
            variant="contained"
            onClick={async () => {
              try {
                await createNullNpsScore();
                setShowConfirmDialog(false);
                setShowNpsModal(false);
              } catch (error) {
                console.log(error);
                setShowConfirmDialog(false);
              }
            }}
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog> */}
    </>
  );
}

export default Dashboard;
